import axios from "axios";

const apiClient = axios.create({
  baseURL: "https://valserve.planeasy.co.in",
  withCredentials: true,
});

export { apiClient };
